import React from "react"
import logo from "./images/naow_logo.svg"

const Overlay = () => {
    return (
        <div className="fullcontainer">
            <div id="logocontainer">
                <a href="https://naow.studio" target="_blank" rel="noopener noreferrer">
                    <img src={logo} alt="naow studio logo" />
                </a>
            </div>
        </div>
    )
}

export default Overlay
